/* ============================================================
   Flossei — homepage behaviour
   Marquee reviews · sticky buy bar · scroll reveal · FAQ schema
   No dependencies. Degrades gracefully without JS.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function initials(name) {
    var parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '★';
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }

  /* ------------------------------------------------- 0. Scroll container */
  /* Horizon and several other Shopify themes set html/body to
     overflow:hidden and scroll an inner wrapper instead, so window scroll
     events never fire and window.pageYOffset stays at 0. Find whatever is
     actually scrolling before wiring anything to it. */
  function findScroller() {
    var de = document.documentElement;
    if (de.scrollHeight > de.clientHeight + 40) return window;

    function scrollable(el) {
      if (!el || el.clientHeight < 300) return false;
      if (el.scrollHeight - el.clientHeight < 200) return false;
      var oy = window.getComputedStyle(el).overflowY;
      return oy === 'auto' || oy === 'scroll';
    }

    var known = document.querySelectorAll(
      '.page-wrapper, #MainContent, main, body > div'
    );
    for (var i = 0; i < known.length; i++) {
      if (scrollable(known[i])) return known[i];
    }

    var all = document.querySelectorAll('body *');
    var best = null, bestDiff = 0;
    for (var j = 0; j < all.length; j++) {
      if (!scrollable(all[j])) continue;
      var diff = all[j].scrollHeight - all[j].clientHeight;
      if (diff > bestDiff) { bestDiff = diff; best = all[j]; }
    }
    return best || window;
  }

  var scroller = null;
  function getScroller() {
    if (!scroller) scroller = findScroller();
    return scroller;
  }
  function scrollOffset() {
    var s = getScroller();
    return s === window
      ? (window.pageYOffset || document.documentElement.scrollTop || 0)
      : s.scrollTop;
  }

  /* ---------------------------------------------------- 1. Reviews marquee */
  function reviewCard(r) {
    return '<figure class="fl-rev__card">' +
      '<div class="fl-rev__stars" aria-label="5 out of 5 stars">★★★★★</div>' +
      '<blockquote class="fl-rev__quote">“' + esc(r.quote) + '”</blockquote>' +
      '<figcaption class="fl-rev__by">' +
        '<span class="fl-rev__av" aria-hidden="true">' + esc(initials(r.name)) + '</span>' +
        esc(r.name) +
      '</figcaption>' +
    '</figure>';
  }

  function buildMarquee(root, reviews) {
    if (!reviews || !reviews.length) {
      if (root.parentNode) root.parentNode.removeChild(root);
      return;
    }

    var mid = Math.ceil(reviews.length / 2);
    var sets = [reviews.slice(0, mid), reviews.slice(mid)];
    var suffix = ['a', 'b'];
    var html = '';

    for (var i = 0; i < sets.length; i++) {
      var set = sets[i];
      if (!set.length) continue;
      var cards = set.map(reviewCard).join('');
      html +=
        '<div class="fl-rev__viewport">' +
          '<div class="fl-rev__row fl-rev__row--' + suffix[i] + '">' +
            cards +
            /* Duplicate set makes the -50% translate loop seamless.
               aria-hidden so each review is announced only once. */
            '<span aria-hidden="true" style="display:contents">' + cards + '</span>' +
          '</div>' +
        '</div>';
    }
    root.innerHTML = html;
    gateMarquees(root);
  }

  /* Only animate a rail while it is on screen. Each rail is ~5000px wide;
     animating both permanently keeps two large compositor layers alive for
     the entire page and burns CPU on mobile. */
  function gateMarquees(root) {
    var views = root.querySelectorAll('.fl-rev__viewport');
    if (!views.length) return;
    if (reduce || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('is-live', e.isIntersecting);
      });
    }, { rootMargin: '200px 0px' });

    for (var i = 0; i < views.length; i++) io.observe(views[i]);
  }

  function initReviews() {
    var root = document.getElementById('fl-reviews-rows');
    if (!root) return;
    var src = root.getAttribute('data-src');
    if (!src) return;

    fetch(src)
      .then(function (r) {
        if (!r.ok) throw new Error('reviews ' + r.status);
        return r.json();
      })
      .then(function (data) { buildMarquee(root, data); })
      .catch(function () {
        /* Keep the heading and disclaimer; drop the empty rail. */
        if (root.parentNode) root.parentNode.removeChild(root);
      });
  }

  /* ---------------------------------------------------- 2. Sticky buy bar */
  function initBuyBar() {
    var bar = document.getElementById('fl-buybar');
    if (!bar) return;

    var target = getScroller();
    var footer = document.querySelector('footer') ||
                 document.getElementById('shopify-section-footer');

    var ticking = false;
    function update() {
      ticking = false;
      /* Reveal past roughly one screen, then hide again near the footer so
         it never covers the real add-to-cart or the legal links. */
      var show = scrollOffset() > window.innerHeight * 0.9;
      if (show && footer) {
        var fTop = footer.getBoundingClientRect().top;
        if (fTop < window.innerHeight) show = false;
      }
      bar.classList.toggle('is-on', show);
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    target.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    /* Belt and braces: if the theme swaps its scroll container after load. */
    if (target !== window) {
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    update();
  }

  /* ---------------------------------------------------- 3. Scroll reveal */
  function initReveal() {
    var els = document.querySelectorAll('.fl-reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  }

  /* ------------------------------------------- 4. FAQPage structured data */
  /* Built from the FAQ already rendered on the page, so the schema can never
     drift from the visible copy — a Google rich-results requirement. */
  function initFaqSchema() {
    var items = document.querySelectorAll('.om-faq__item');
    if (!items.length) return;
    if (document.getElementById('fl-faq-schema')) return;

    var faqs = [];
    for (var i = 0; i < items.length; i++) {
      var q = items[i].querySelector('summary');
      var a = items[i].querySelector('.om-faq__answer');
      if (!q || !a) continue;
      var qt = (q.textContent || '').trim();
      var at = (a.textContent || '').trim().replace(/\s+/g, ' ');
      if (!qt || !at) continue;
      faqs.push({
        '@type': 'Question',
        name: qt,
        acceptedAnswer: { '@type': 'Answer', text: at }
      });
    }
    if (!faqs.length) return;

    var s = document.createElement('script');
    s.type = 'application/ld+json';
    s.id = 'fl-faq-schema';
    s.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs
    });
    document.head.appendChild(s);
  }

  /* ---------------------------------------------------- 5. Comparison hint */
  /* Show the swipe affordance only when the table actually overflows. */
  function initCmpHint() {
    var wraps = document.querySelectorAll('.fl-cmp__scroll');
    for (var i = 0; i < wraps.length; i++) {
      (function (w) {
        var hint = w.parentNode.querySelector('.fl-cmp__hint');
        if (!hint) return;
        function check() {
          hint.style.display = w.scrollWidth > w.clientWidth + 4 ? 'block' : 'none';
        }
        check();
        window.addEventListener('resize', check, { passive: true });
      })(wraps[i]);
    }
  }

  function boot() {
    initReviews();
    initBuyBar();
    initReveal();
    initFaqSchema();
    initCmpHint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
